import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  usePermissions,
  useNotify,
  useRedirect,
} from "react-admin";

export const PermissionCreate = (props) => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();

  if (
    !(
      permissions.includes("permissions.create") ||
      permissions.includes("permissions.*") ||
      permissions.includes("*")
    )
  )
    return null;

  return (
    <Create
      title="Create Permission"
      {...props}
      mutationOptions={{
        onSuccess: () => {
          notify("Permission created successfully", { type: "success" });
          redirect("list", "permissions"); // ✅ works reliably
        },
        onError: () => {
          notify("Error creating permission", { type: "error" });
        },
      }}
    >
      <SimpleForm>
        <TextInput source="name" required />

        <SelectInput
          source="resource"
          required
          choices={[
            { id: "Users", name: "Users" },
            { id: "Roles", name: "Roles" },
            { id: "Groups", name: "Groups" },
            { id: "Permissions", name: "Permissions" },
            { id: "Forms", name: "Forms" },
            { id: "Certificate", name: "Certificate" },
            { id: "User-guides", name: "User-guides" },
            { id: "Assessments", name: "Assessments" },
            { id: "*", name: "*" },

          ]}
        />

        <SelectInput
          source="action"
          required
          choices={[
            { id: "Create", name: "Create" },
            { id: "Read", name: "Read" },
            { id: "Edit", name: "Edit" },
            { id: "Delete", name: "Delete" },
            { id: "*", name: "*" },
          ]}
        />

        <TextInput source="description" />
      </SimpleForm>
    </Create>
  );
};